import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "pina_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const acceptAll = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };
  const rejectAll = () => {
    localStorage.setItem(COOKIE_KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-50 bg-white border border-slate-200 rounded-2xl shadow-2xl p-5"
      role="dialog"
      aria-label="Aviso de cookies"
    >
      <h3 className="font-bold text-slate-900 mb-1.5">Uso de cookies</h3>
      <p className="text-sm text-slate-600 leading-relaxed mb-4">
        Usamos cookies técnicas para el correcto funcionamiento del sitio. Puedes aceptarlas o
        rechazar las no esenciales. Consulta nuestra{" "}
        <Link to="/cookies" className="text-teal-700 underline font-medium">
          política de cookies
        </Link>
        {" "}y{" "}
        <Link to="/privacidad" className="text-teal-700 underline font-medium">
          política de privacidad
        </Link>.
      </p>
      <div className="flex gap-2">
        <button
          onClick={rejectAll}
          data-testid="cookie-reject"
          className="flex-1 px-4 py-2.5 rounded-full border border-slate-300 text-slate-700 hover:bg-slate-50 text-sm font-semibold transition-colors"
        >
          Rechazar
        </button>
        <button
          onClick={acceptAll}
          data-testid="cookie-accept"
          className="flex-1 px-4 py-2.5 rounded-full bg-orange-600 text-white hover:bg-orange-700 text-sm font-semibold transition-colors"
        >
          Aceptar todas
        </button>
      </div>
    </div>
  );
}
